import React from 'react'

function Hero() {
  return (
    <div className="mb-8 animate-fade-in-up">
      {/* Main Headline */}
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-700 mb-6 leading-tight">
        Coming Soon
      </h1>

      {/* Main Tagline */}
      <p className="text-xl sm:text-2xl text-gray-700 mb-4 max-w-3xl mx-auto leading-relaxed font-medium">
        Caring for your loved ones like family.
      </p>

      {/* Sub-Tagline */}
      <p className="text-lg sm:text-xl text-cp-primary mb-6 max-w-3xl mx-auto leading-relaxed font-semibold">
        Real care. Real people. Smart technology.
      </p>

      {/* Mission Statement */}
      <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-4xl mx-auto leading-relaxed">
        An AI-powered home health network connecting families, caregivers, and technology. 
        Stay connected and informed about your loved ones' care in real-time through innovation and compassion.
      </p>
    </div>
  )
}

export default Hero